{
  "version": "1.2.6",
  "objects": {
    "7430093515430142733": {
      "type": "frame",
      "id": "7430093515430142733",
      "z": 7273,
      "textContent": "",
      "left": -1058.9060742361248,
      "top": 2237.8473991970327,
      "width": 400,
      "height": 500,
      "scaleX": 0.7694665816350448,
      "scaleY": 0.09858628735634853,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7430093515432995608": {
      "type": "shape",
      "id": "7430093515432995608",
      "z": 7029,
      "shapeName": "icon",
      "textContent": "",
      "left": -774.3817377493194,
      "top": 2254.78413410235,
      "width": 100,
      "height": 160,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.10262296167212569,
      "scaleY": 0.10262296167212569,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#BDBDBD",
      "angle": 0,
      "container": "7430093515430142733",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "iconName": "fas/xmark",
      "locked": false
    },
    "7430093515434856913": {
      "type": "wireframe",
      "id": "7430093515434856913",
      "z": 7030,
      "top": 2248.3473991970327,
      "left": -1048.9060742361248,
      "width": 52,
      "height": 52,
      "scaleX": 0.5633296861187359,
      "scaleY": 0.5633296861187359,
      "container": "7430093515430142733",
      "layoutPosition": "Zzzzzx",
      "wireframeName": "avatar",
      "fill": "#3AA78B",
      "textColor": "#333333",
      "style": "square",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "circle-check" },
        "iconRight": null
      },
      "showBackground": true,
      "showOutline": true
    },
    "7430093515438003490": {
      "type": "frame",
      "id": "7430093515438003490",
      "z": 7031,
      "textContent": "Frame 96",
      "left": -1009.6129305579506,
      "top": 2250.49397103612,
      "width": 400,
      "height": 500,
      "scaleX": 0.5630779820215777,
      "scaleY": 0.05,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430093515430142733",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7430093515437340900": {
      "type": "shape",
      "id": "7430093515437340900",
      "z": 7032,
      "shapeName": "text",
      "textContent": "<p>Success banner description</p>",
      "left": -1009.6129305579506,
      "top": 2250.49397103612,
      "width": 182,
      "height": 29.166666666666668,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7430093515438003490",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    }
  }
}
